/**
 * Convert HTML date input value (YYYY-MM-DD) to UNIX timestamp in seconds.
 * Returns undefined for falsy or invalid values.
 */
export const toUnix = (value?: string): string | undefined => {
  if (!value) return undefined;
  const ts = new Date(value).getTime();
  if (Number.isNaN(ts)) return undefined;
  return String(Math.floor(ts / 1000));
};

export default toUnix;
